import { Modal } from 'antd';
import { t } from 'i18next';
import i18n from './i18n';
import { UNKNOWN_ERROR_MESSAGE } from '@/config';

export const defaultApiErrorHandle = (error: any) => {
  Modal.error({
    get title() { return t('Error'); },
    content: i18n.t(error.message || UNKNOWN_ERROR_MESSAGE),
  });
};
